<template>
  <div class="list-wrap" ref="scroll">
    <!-- 列表标题 -->
    <div class="list-title">社区支部管理</div>

    <!--------------------- 社区大党委 --------------------->
    <section class="ddw-wrap section-wrap">
      <!-- 头部 -->
      <div class="header">
        <!-- 标题 -->
        <div class="header_title">{{ ddw.zoneName || "" }}</div>
        <!-- 编辑按钮 -->
        <Button
          class="edit-btn header_edit-btn"
          type="warning"
          @click="
            toDetail({
              type: 'ddw',
              query: { id: ddw.id, zoneType: ddw.zoneType },
            })
          "
          >编辑</Button
        >
      </div>
      <!-- 主体 -->
      <div class="body" v-if="!ddwNoData">
        <!-- 大党委左侧 -->
        <div class="ddw-body_left">
          <div class="body_inner-title">{{ ddw.sj.name }}</div>
          <div class="ddw-body_left_main">
            <bk-person
              v-for="item in ddw.sj.value"
              :key="item.id"
              :editable="false"
              :showPhone="false"
              :nameFontSize="24"
              :jobFontSize="18"
              :user="item"
            ></bk-person>
          </div>

          <div class="body_inner-title">{{ ddw.sj1.name }}</div>
          <div class="ddw-body_left_main">
            <bk-person
              v-for="item in ddw.sj1.value"
              :key="item.id"
              :editable="false"
              :showPhone="false"
              :nameFontSize="24"
              :jobFontSize="18"
              :user="item"
            ></bk-person>
          </div>
        </div>
        <!-- 大党委右侧 -->
        <div class="ddw-body_right">
          <!-- 专职委员 -->
          <div class="ddw-body_right--top">
            <div class="body_inner-title">{{ ddw.zz.name }}</div>
            <div class="ddw-body_right_main">
              <bk-person
                v-for="item in ddw.zz.value"
                :key="item.id"
                :user="item"
                :editable="false"
                :showPhone="false"
                :nameFontSize="24"
                :jobFontSize="18"
                class="body_inner-person"
              ></bk-person>
            </div>
          </div>
          <!-- 兼职委员 -->
          <div class="ddw-body_right--bottom">
            <div class="body_inner-title">{{ ddw.jz.name }}</div>
            <div class="ddw-body_right_main">
              <bk-person
                v-for="item in ddw.jz.value"
                :key="item.id"
                :user="item"
                :editable="false"
                :showPhone="false"
                :nameFontSize="24"
                :jobFontSize="18"
                class="body_inner-person"
              ></bk-person>
            </div>
          </div>
        </div>
      </div>
      <!-- 无数据的主体 -->
      <div class="body body--no-data" v-else>
        <div class="no-data_info">您还没有维护社区大党委成员信息</div>
        <div
          class="no-data_link"
          @click="
            toDetail({
              type: 'ddw',
              query: { id: ddw.id, zoneType: ddw.zoneType },
            })
          "
        >
          去编辑 &gt;
        </div>
      </div>
    </section>

    <!--------------------- 两代表一委员 --------------------->
    <section class="section-wrap">
      <!-- 头部 -->
      <div class="header">
        <!-- 标题 -->
        <div class="header_title">{{ ldb.zoneName }}</div>
        <!-- 编辑按钮 -->
        <Button
          class="edit-btn header_edit-btn"
          type="warning"
          @click="toDetail({ type: 'ldb', query: { id: ldb.id } })"
          >编辑</Button
        >
      </div>
      <div class="body llb-body" v-if="!ldbNoData">
        <bk-person
          class="body_inner-person"
          v-for="item in ldb.personList"
          :key="item.id"
          :user="item"
          :editable="false"
          :showPhone="false"
          :nameFontSize="24"
          :jobFontSize="18"
        ></bk-person>
      </div>
      <!-- 无数据的主体 -->
      <div class="body body--no-data" v-else>
        <div class="no-data_info">您还没有维护成员信息</div>
        <div
          class="no-data_link"
          @click="toDetail({ type: 'ldb', query: { id: ldb.id } })"
        >
          去添加 &gt;
        </div>
      </div>
    </section>

    <!--------------------- 自管党支部 --------------------->
    <section class="section-wrap">
      <!-- 头部 -->
      <div class="header">
        <!-- 标题 -->
        <div class="header_title">自管党支部</div>
        <!-- 编辑按钮 -->
        <Button
          class="edit-btn header_edit-btn"
          type="warning"
          @click="addOrg(dzzBranch)"
          >添加</Button
        >
      </div>
      <div class="body zgd-body">
        <!-- 头部 -->
        <div class="header zgd-header">
          <!-- 标题 -->
          <div class="header_title zgd-header_title">{{ dzz.zoneName }}</div>
          <!-- 编辑按钮 -->
          <Button
            class="edit-btn"
            type="warning"
            @click="
              toDetail({
                type: 'dzz',
                query: {
                  id: dzz.id,
                  zoneType: dzz.zoneType,
                  selfType: dzz.zoneType,
                },
              })
            "
            >编辑</Button
          >
        </div>
        <!-- 主体内容 -->
        <div class="zgd-content" v-if="!dzzNoData">
          <div class="zgd-content_left">
            <div class="body_inner-title">{{ dzz.sj.name }}</div>
            <div class="zgd-content_left_main">
              <bk-person
                v-for="item in dzz.sj.value"
                :key="item.id"
                :user="item"
                :editable="false"
                :showPhone="false"
                :nameFontSize="24"
                :jobFontSize="18"
                class="body_inner-person"
              ></bk-person>
            </div>
          </div>
          <div class="zgd-content_right">
            <div class="body_inner-title">{{ dzz.other.name }}</div>
            <div class="zgd-content_right_main">
              <bk-person
                v-for="item in dzz.other.value"
                :key="item.id"
                :user="item"
                :editable="false"
                :showPhone="false"
                :nameFontSize="24"
                :jobFontSize="18"
                class="body_inner-person"
              ></bk-person>
            </div>
          </div>
        </div>
        <!-- 无数据的主体 -->
        <div class="body body--no-data zgd-content--no-data" v-else>
          <div class="no-data_info">您还没有维护{{ dzz.zoneName }}成员信息</div>
          <div
            class="no-data_link"
            @click="
              toDetail({
                type: 'dzz',
                query: {
                  id: dzz.id,
                  zoneType: dzz.zoneType,
                  selfType: dzz.zoneType,
                },
              })
            "
          >
            去编辑 &gt;
          </div>
        </div>
      </div>
      <!-- 主体列表 -->
      <div class="zgd-list">
        <bk-orgcard
          v-for="item in dzzBranchList"
          :key="item.id"
          :party="item"
          @on-click="
            toDetail({
              type: 'dzz',
              query: { id: item.id, zoneType: dzz.zoneType, selfType: 2 },
            })
          "
          @on-edit="
            toDetail({
              type: 'dzz',
              query: { id: item.id, zoneType: dzz.zoneType, selfType: 2 },
            })
          "
          @on-delete="onDeleteOrg(item, getDzzBranch)"
        ></bk-orgcard>
      </div>
    </section>

    <!--------------------- 辖区党组织 --------------------->
    <section class="section-wrap">
      <!-- 头部 -->
      <div class="header">
        <!-- 标题 -->
        <div class="header_title">辖区党组织</div>
        <!-- 编辑按钮 -->
        <Button
          class="edit-btn header_edit-btn"
          type="warning"
          @click="addOrg(orgOther)"
          >添加</Button
        >
      </div>
      <!-- 列表 -->
      <div class="xqd-list" v-if="!otherNoData">
        <bk-orgcard
          v-for="item in orgOtherList"
          :key="item.id"
          :party="item"
          @on-click="
            toDetail({
              type: 'dzz',
              query: { id: item.id, zoneType: 2, selfType: 2 },
            })
          "
          @on-edit="
            toDetail({
              type: 'dzz',
              query: { id: item.id, zoneType: 2, selfType: 2 },
            })
          "
          @on-delete="onDeleteOrg(item, getOtherList)"
        ></bk-orgcard>
      </div>
      <!-- 无数据的主体 -->
      <div class="body body--no-data" v-else>
        <div class="no-data_info">
          您可以在这里添加
          <span class="no-data_info--focus">{{ otherNoDataInfo }}</span
          >等
        </div>
        <div class="no-data_link" @click="addOrg(orgOther)">去添加 &gt;</div>
      </div>
      <!-- 列表分页 -->
      <Page
        class="xqd-page"
        :total="otherTotal"
        :page-size="otherPageSize"
        show-total
        @on-change="onPageChange"
      ></Page>
    </section>

    <!-- form-modal -->
    <form-modal
      :modal="org_modal"
      :form-option="org_option"
      @on-ok="onModalConfirm"
    ></form-modal>

    <!-- 添加成功的modal -->
    <Modal v-model="addComplete" footer-hide title="添加">
      <div class="complete-wrap">
        <div class="complete-img-wrap">
          <img src="@/assets/images/add-complete.png" title="添加完成" />
        </div>
        <span class="complete-tip">您可以继续完善支部成员信息</span>
        <Button
          class="edit-btn complete-btn"
          type="warning"
          @click="toDetailByModal"
          >完善信息</Button
        >
        <span class="complete-close" @click="addComplete = false"
          >稍后填写</span
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import bkPerson from "./components/person";
import bkOrgcard from "./components/org-card";
import formModal from "@/components/form-modal";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$refs.scroll.scrollTop = vm.scrollTop;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.scrollTop = this.$refs.scroll.scrollTop;
    next();
  },
  components: { bkPerson, bkOrgcard, formModal },
  props: {},
  data() {
    return {
      scrollTop: 0, // list 的滚动距离
      orgId: "", // 当前选择行政区域的id
      filterList: [], // 右侧栏的过滤选项
      filterCurIndex: 0, // 过滤器的当前索引值
      ddw: {
        sj: {
          name: "",
          value: [],
        }, // 书记
        sj1: {
          name: "",
          value: [],
        },
        zz: {
          name: "",
          value: [],
        }, // 专职
        jz: {
          name: "",
          value: [],
        }, // 兼职
      }, // 大党委数据
      ldb: {
        personList: [],
      }, // 两代表
      dzz: {
        sj: {
          name: "",
          value: [],
        }, // 支部书记
        other: {
          name: "",
          value: [],
        }, // 其他委员
      }, // 党总支
      org_modal: {
        value: false,
        title: "添加",
      },
      org_option: [],
      // 党总支分支部表单
      dzzBranch: {
        // 固定的参数
        params: {
          zoneType: 2,
          orgTypeId: 0,
        },
        getOption() {
          return [
            {
              type: "input",
              name: "name",
              title: "支部名称",
            },
            {
              type: "map",
              name: "map",
              title: "支部位置",
            },
          ];
        },
      },
      dzzBranchList: [], // 党总支分支部列表
      // 其他支部表单
      orgOther: {
        params: {
          zoneType: 2,
        },
        selectData: [],
        getOption() {
          return [
            {
              type: "select",
              name: "orgType",
              title: "支部类型",
              data: this.selectData,
            },
            {
              type: "input",
              name: "name",
              title: "支部名称",
            },
            {
              type: "map",
              name: "map",
              title: "支部位置",
            },
          ];
        },
      },
      orgOtherList: [], // 其他支部列表
      otherTotal: 0, // 总数
      otherPageNum: 1, // 辖区党组织分页
      otherPageSize: 6, // 辖区党组织分页

      addComplete: false, // 添加完成显示的modal
    };
  },
  watch: {
    // 监听 社区id的切换变化
    orgId(val) {
      this.$parent.curOrgId = val;
    },
  },
  computed: {
    /* 大党委无数据 */
    ddwNoData() {
      let tmp = this.ddw;
      return (
        !tmp.sj.value.length &&
        !tmp.sj1.value.length &&
        !tmp.zz.value.length &&
        !tmp.jz.value.length
      );
    },
    /* 两党员无数据 */
    ldbNoData() {
      return this.ldb.personList.length === 0;
    },
    /* 党总支无数据 */
    dzzNoData() {
      return (
        this.dzz.sj.value.length === 0 && this.dzz.other.value.length === 0
      );
    },
    /* 辖区党组织无数据 */
    otherNoData() {
      return this.orgOtherList.length === 0;
    },
    /* 辖区党组织无数据时的提示 */
    otherNoDataInfo() {
      return this.orgOther.selectData
        .slice(0, 2)
        .map((item) => item.label)
        .join("、");
    },
  },
  created() {
    // 初始化页面事件总线
    this.initEventBus();
    // 获取过滤器
    this.getFilterList();
    // 过滤器重置
    this.reset = this._.debounce(this._reset, 500);
  },
  mounted() {
    this.getDefaultList();
    this.getDzzBranch();
    this.getOtherList();
    // 获取辖区党组织类别字典
    this.getOrgType();
  },
  activated() {},
  beforeDestroy() {
    // console.log("beforeDestroy");
    // 取消事件总线监听 人员变化监听
    this.$bus.$off([
      "miniParty_orgNumberChange",
      "miniParty_personChange",
      "miniParty_branchPersonChange",
      "miniParty_otherPersonChange",
    ]);
  },
  methods: {
    /* 注册页面的事件总线 */
    initEventBus() {
      // 组织数发生变化 重新刷新 党总支数
      this.$bus.$on("miniParty_orgNumberChange", this.getFilterList);
      // 大党委 两代表 党总支 人员数量变化
      this.$bus.$on("miniParty_personChange", this.getDefaultList);
      // 党支部分支部 或 辖区党组织 信息 或 人员数量变更
      this.$bus.$on("miniParty_branchPersonChange", this.getDzzBranch);
      this.$bus.$on("miniParty_otherPersonChange", this.getOtherList);
    },
    /* 获取右侧过滤器列表 */
    getFilterList() {
      let url = this.urlobj.partyLabel;
      this.$get(url)
        .then((res) => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          // 显示文本组件
          this.$store.commit("updateLabelList", [
            {
              name: "filter_label",
              data: {
                label: "基层党组织总数",
                value: res.newPrimaryKeys.partyCount,
              },
            },
          ]);
          // 过滤器组件
          let singleDivisionDataList = res.rows.map((item) => {
            return {
              id: item.communityId,
              label: item.communityName,
              number: item.partyCount,
            };
          });
          this.filterList = [
            {
              name: "singleDivision",
              data: {
                title: "行政区域",
                edit: false,
                selectedIndex: this.filterCurIndex,
                dataList: singleDivisionDataList,
              },
              event: (e) => {
                this[e.fn](e);
              },
            },
          ];
          this.$store.commit("updateFilterList", this.filterList);
          // 初始的orgid
          this.orgId = singleDivisionDataList[this.filterCurIndex].id;
          this.orgName = singleDivisionDataList[this.filterCurIndex].label;
        })
        .catch((e) => {
          this.$Message.error("分类获取失败");
        });
    },
    /* 行政区域发生变化 */
    areaChange({ params }) {
      // 更新选中索引
      this.filterCurIndex = params.selectedIndex;
      // 更新orgId
      // prettier-ignore
      let cur = this.filterList[params.filterListIndex].data.dataList[params.selectedIndex];
      this.orgId = cur.id;
      this.orgName = cur.label;
      // 重新请求页面
      this.getDefaultList();
      this.getDzzBranch();
      this.getOtherList();
    },
    /* 过滤器重置 */
    _reset() {
      // 右侧暂时只有一个组件 多个可重新初始化组件以重置
      this.filterList[0].data.selectedIndex = 0;
    },
    /* 获取默认列表 */
    getDefaultList() {
      let url = this.urlobj.getDefaultPartyList(-1); // 查询全部
      let data = {
        communityId: this.orgId, // 没有值的话自动取当前登录社区
      };
      this.$showLoading();
      this.$get(url, data)
        .then((res) => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          // 大党委，两代表，党总支
          for (let item of res.rows) {
            if (item.zoneType === 24) Object.assign(this.ddw, item);
            if (item.zoneType === 23) Object.assign(this.ldb, item);
            if (item.zoneType === 22) Object.assign(this.dzz, item);
          }
          // 临时组
          let _point = [this.ddw.sj, this.ddw.sj1, this.ddw.zz, this.ddw.jz];
          // 大党委数据
          Object.keys(this.ddw.userMapList).forEach((item, index) => {
            if (!_point[index]) return;
            console.log(_point[index]);
            _point[index].name = item;
            _point[index].value = this.ddw.userMapList[item] || [];
          });

          // 两代表数据
          let ldbPersonlistDefault = [];
          for (let item of Object.keys(this.ldb.userMapList)) {
            ldbPersonlistDefault.push(...this.ldb.userMapList[item]);
          }
          this.ldb.personList = ldbPersonlistDefault;

          // 自管党支部数据
          _point = [this.dzz.sj, this.dzz.other]; // 党总支 只取前两个

          Object.keys(this.dzz.userMapList).forEach((item, index) => {
            if (!_point[index]) return;
            _point[index].name = item;
            _point[index].value = this.dzz.userMapList[item] || [];
          });
        })
        .finally(this.$hideLoading);
    },
    /* 党支部分支部列表 */
    getDzzBranch() {
      let url = this.urlobj.partyList(1);
      let data = {
        communityId: this.orgId,
      };
      this.$get(url, data).then((res) => {
        if (!res.isSucceed) return this.$Message.error(res.message);

        this.dzzBranchList = res.rows;
      });
    },
    /* 获取支部类型字典 */
    getOrgType() {
      let url = this.urlobj.dictionaryList("party_org");
      this.$get(url).then((res) => {
        if (res.isSucceed) {
          this.orgOther.selectData = res.rows.map((item) => {
            return {
              label: item.dicName,
              value: item.id,
            };
          });
        }
      });
    },
    /* 获取辖区党组织列表 */
    getOtherList() {
      let url = this.urlobj.partyList(0);
      let data = {
        communityId: this.orgId,
        pageNum: this.otherPageNum,
        pageSize: this.otherPageSize,
      };
      this.$get(url, data).then((res) => {
        if (!res.isSucceed) return this.$Message.error(res.message);

        this.orgOtherList = res.rows;
        this.otherTotal = res.total;
      });
    },
    /* 分页器变化 */
    onPageChange(newPageNum) {
      this.otherPageNum = newPageNum;
      this.getOtherList();
    },
    /* 打开modal */
    addOrg(orgOption) {
      // 存储当前 option对象
      this.curOption = orgOption;
      this.org_modal.value = true;
      this.org_option = orgOption.getOption();
    },
    /* modal 确定 */
    onModalConfirm(formOption) {
      let name = formOption.get("name"),
        map = formOption.get("map"),
        orgType = formOption.get("orgType");

      let url = this.urlobj.party;
      let data = {
        communityId: this.orgId,
        zoneName: name.value,
        address: map.value,
        coordinate: JSON.stringify({ x: map.longitude, y: map.latitude }),
        ...this.curOption.params,
      };
      // 辖区党组织 配置额外参数
      if (orgType) data.orgTypeId = orgType.value;

      this.$showLoading();
      this.$post(url, data)
        .then((res) => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.addComplete = true; // 弹出提示框
          this.curCompleteId = res.newPrimaryKeys.id;
          // 刷新列表
          if (this.curOption === this.dzzBranch) this.getDzzBranch();
          if (this.curOption === this.orgOther) this.getOtherList();

          // 更新党组织数
          this.$bus.$emit("miniParty_orgNumberChange");
        })
        .finally(this.$hideLoading);
    },
    /* 删除组织 */
    onDeleteOrg(org, cb) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确认要进行删除操作吗？</p>",
        onOk: () => {
          // 执行删除操作
          let url = this.urlobj.partyDelete(org.id);
          this.$delete(url).then((res) => {
            if (!res.isSucceed) return this.$Message.error(res.message);
            this.$Message.success("删除成功");
            // 刷新列表
            cb && cb();
            // 更新党组织数
            this.$bus.$emit("miniParty_orgNumberChange");
          });
        },
      });
    },
    /* 点击不同的按钮跳转至详情索引页 */
    toDetail({ type = "", query = {} } = {}) {
      this.$router.push({
        name: "detail-index",
        params: {
          type,
        },
        query: {
          orgId: this.orgId, // 当前选中的社区id
          orgName: this.orgName,
          ...query,
        },
      });
    },
    /* 通过modal 跳转详情 */
    toDetailByModal() {
      let params = {
        type: "dzz",
        query: {
          id: this.curCompleteId,
          zoneType: 22,
          selfType: 2,
        },
      };
      // 其他分支部
      if (this.curOption === this.orgOther) {
        params.query.zoneType = 2;
      }
      // 关闭modal
      this.addComplete = false;
      this.toDetail(params);
    },
  },
};
</script>
<style lang="less" scoped>
@titleColor: #666;
@titleFontSize: 24px;
@titleFontSizeFix: 22px;
@bodyPadding: 20px;

.list-wrap {
  box-sizing: border-box;
  padding: 30px 20px;

  height: calc(100vh - 60px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
.list-title {
  font-size: @titleFontSize;
  color: @titleColor;
  text-align: center;
}
.section-wrap {
  margin-top: 30px;
  margin-bottom: 30px;
}
.header {
  .flex(center, center);
}
.header_title {
  flex: 1;
  color: @titleColor;
  font-size: @titleFontSize;
  font-weight: 600;
  text-align: center;
  margin-right: calc(-60px - @bodyPadding); // 编辑按钮占据宽度
}
.edit-btn {
  font-size: 14px;
  color: #fff;
  line-height: 1;
  background-color: #ff7b44;
}
.header_edit-btn {
  margin-right: @bodyPadding;
}
.body {
  .flex();
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 3px;
  margin-top: 20px;
}
.ddw-body_left,
.zgd-content_left {
  flex: 1;
  border-right: 1px solid #ddd;
  .flex(@flexDirection:column);
}
.body_inner-title {
  font-size: @titleFontSizeFix;
  color: @titleColor;
  padding: 12px 20px;
  background-color: #f9f9f9;
}
.body_inner-person {
  margin-right: 40px;
  margin-bottom: 20px;
}
.ddw-body_left_main,
.zgd-content_left_main {
  flex: 1;
  .flex(center, center);
}
.ddw-body_right,
.zgd-content_right {
  flex: 2;
}
.ddw-body_right_main,
.zgd-content_right_main {
  .flex(flex-start, @flexWrap:wrap);
  padding: @bodyPadding;
}
/* 两代表一委员 */
.llb-body {
  .flex(flex-start, @flexWrap:wrap);
  justify-content: center;
  position: relative;
  padding: @bodyPadding;
}
/* 自管党支部 */
.zgd-header {
  width: 100%;
  padding: 10px @bodyPadding;
}
.zgd-header_title {
  font-size: @titleFontSizeFix;
  font-weight: normal;
  margin-right: -60px;
}
.zgd-body {
  display: block;
}
.zgd-content {
  .flex();
}
.zgd-list,
.xqd-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(510px, 1fr));
  grid-gap: 30px;

  margin-top: 20px;
}
.xqd-page {
  margin-top: 20px;
  text-align: right;
}
/* 无数据 */
.body--no-data {
  .flex(center, center, @flexDirection:column);
  height: 240px;
}
/* 自管党无数据 */
.zgd-content--no-data {
  border: none;
  height: calc(240px - 53px - 20px); // header大概高度 margin 高度
}
.no-data_info {
  color: #666;
  font-size: 16px;
  margin-bottom: 15px;
}
.no-data_info--focus {
  color: #ff7b44;
}
.no-data_link {
  font-size: 16px;
  color: #677a9e;
  cursor: pointer;
}
// 添加完成的弹窗
.complete-wrap {
  .flex(center, @flexDirection:column);
}
.complete-img-wrap {
  position: relative;
  margin-bottom: 30px;
  &::before {
    content: "恭喜您";
    position: absolute;
    top: 33px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
    color: #f99c5e;
  }
  &::after {
    content: "添加成功";
    position: absolute;
    bottom: 42px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
    color: #f99c5e;
  }
}
.complete-tip {
  font-size: 14px;
  color: #999;
}
.complete-btn {
  margin: 15px 0;
}
.complete-close {
  font-size: 14px;
  color: #ff7b44;
  cursor: pointer;
}
</style>
